// extracted by mini-css-extract-plugin
export default {"vehicleSummaryList":"styles_vehicleSummaryList__k23ky","vehicleSummaryItem":"styles_vehicleSummaryItem__mA50O"};